import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useRejectedReviewQuery({ reviewId }) {
  return useQuery({
    queryKey: ['rejectedReviews', reviewId],
    queryFn: async () => {
      const response = await axios.get(`/rejected_reviews/${reviewId}`);

      return response.data;
    },
    select: (data) =>
      formatData({
        data,
        resourceTypes: [
          'personnel',
          'profilePhoto',
          'projectPersonnel',
          'version',
        ],
      }),
  });
}
